import { render, staticRenderFns } from "./program-card.vue?vue&type=template&id=45105209"
import script from "./program-card.vue?vue&type=script&lang=js"
export * from "./program-card.vue?vue&type=script&lang=js"
import style0 from "./program-card.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports